import React, { Fragment, useState, useEffect } from "react";
import { useVerifyUserNameContainer } from "./UsernameContainer";
import { trackClickEventProp61 } from "../../../../../utils/omnitureTracker";
import Modal from "react-modal";
import { withRouter } from "react-router-dom";
import "../LoginModals.css";
import { UserFlowModalState } from "../../UserFlow/UserFlowModal";
import { customStyles } from "../../UserFlow/UserFlowModal";
import {
  CHECK,
  I_HAVE_MY_IRCTC_PASSWORD_FOR_THIS_USERNAME,
  SAVE_N_CLOSE,
  USERNAME
} from "./Constants";
import {
  crossIcon,
  IMAGES_CDN,
  IRCTC_AADHAR_FALLBACK,
  IRCTC_USERNAME,
  NUDGE_DESCRIPTION,
  NUDGE_DESCRIPTION_AADHAR
} from "../../IrctcEducationModal/Constants";
import Input2 from "./Input";
import Button from "./Button";
import { AADHAR_LINK } from "../../../../../constants/TrainConstants";
import { DWEB_AADHAR_MODAL_TEXT, getConfigKey } from "../../../../../utils/configStore";

const VerifyIrctcUserNameNew = (props: UserFlowModalState) => {
  const [aadharModalConfig, setAadharModalConfig] = useState(null);

  const {
    props: { showModal, state, irctcUserId, error, isChecked, isVerifiedId,aadharErrorFlow },

    action: {
      saveClose,
      handleCheck,
      checkIRCTCid,
      closeModal,
      closeModalAction,
      goToIRCTCRegistrationPage,
      goToForgotUsernamePage,
      goToForgotPassWordPage,
      handleInputKeyUpViaParent,
      goToAadharMarketing
    }
  } = useVerifyUserNameContainer(props);
  const { disabled, rotate } = state;

  useEffect(() => {
    getConfigKey(DWEB_AADHAR_MODAL_TEXT, IRCTC_AADHAR_FALLBACK).then((config) => {
      setAadharModalConfig(config);
    }).catch(() => {
      setAadharModalConfig(null);
    });
  }, []);
  return (
    <Fragment>
      <Modal
        isOpen={showModal}
        ariaHideApp={false}
        onRequestClose={closeModal}
        className={"loginModals loginModals--v5"}
        id="mmt-irctc-modal"
        style={{
          overlay: {
            backgroundColor: "rgb(0, 0, 0, 0.6)",
            zIndex: 1
          },
          customStyles
        }}
      >
        <p className="font18 latoBlack appendBottom16">{IRCTC_USERNAME}</p>
        <div className="makeAbsolute closeIcon" onClick={closeModalAction}>
          <img src={IMAGES_CDN + crossIcon} className="closeIconDimension" />
        </div>
        {aadharErrorFlow ? (
          <>
            <p className="additionalInfo font14 darkGreyText appendBottom16 borderRadius8">
              {aadharModalConfig?.aadharModal?.educationalText}
            <a
              className={`font14 lineHeight20 latoBold`}
              href={aadharModalConfig?.aadharModal?.moreInfoUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}{aadharModalConfig?.aadharModal?.moreInfoText} 
            </a>
            </p>
          </>
        ) : (
          <p className="additionalInfo font14 darkGreyText appendBottom16 borderRadius8">
            {NUDGE_DESCRIPTION}
          </p>
        )}
        <div className={"makeFlex spaceBetween hrtlCenter height66"}>
          <Input2
            placeHolder={USERNAME}
            value={irctcUserId}
            onChange={handleInputKeyUpViaParent}
            successMsg="Username exists in IRCTC"
            errorMsg={
              aadharErrorFlow
                ? (aadharModalConfig?.aadharModal?.verificationError || "Aadhar verification is pending for this IRCTC username")
                : "Username doesn’t exist in IRCTC database"
            }
            infoMsg={
              rotate
                ? "Checking if the user exists"
                : "Enter the username for your existing IRCTC account"
            }
            error={aadharErrorFlow || error}
            containerStyle={{ flex: 1 }}
            success={!aadharErrorFlow && isVerifiedId}
          />
          <div className="makeFlex hrtlCenterWithContent width168">
            <Button
              onClick={isChecked ? saveClose : checkIRCTCid}
              disabled={disabled || (isVerifiedId ? !isChecked : false)}
              className={`${
                disabled || (isVerifiedId ? !isChecked : false)
                  ? "disabled"
                  : ""
              } noShrink appendLeft20 ${
                rotate ? "spinnerWidth" : "newBtnDimensions"
              }`}
            >
              {" "}
              <span
                className={`${
                  rotate ? "btnLoader" : "font16 latoBlack capText"
                }`}
              >
                {isVerifiedId ? SAVE_N_CLOSE : CHECK}
              </span>
            </Button>
          </div>
        </div>
        {!isVerifiedId && <p className="hrtlSeperater2"></p>}
        <div
          className={`makeFlex hrtlStartWithContent gap24 ${isVerifiedId &&
            "appendTop25 appendBottom20"}`}
        >
          <a
            className={`font16 lineHeight20 latoBold`}
            style={isVerifiedId ? { color: "#757575" } : null}
            onClick={goToForgotUsernamePage}
          >
            Forgot username
          </a>
          <a
            className={`font16 lineHeight20 latoBold`}
            style={isVerifiedId ? { color: "#757575" } : null}
            onClick={goToIRCTCRegistrationPage}
          >
            Create new account
          </a>
          {aadharErrorFlow && (
            <a
              className={`font16 lineHeight20 latoBold`}
              style={isVerifiedId ? { color: "#008cff" } : null}
              onClick={goToAadharMarketing}
            >
              Link Aadhar
            </a>
          )}
        </div>
        {isVerifiedId && <p className="thinHrtlSeperater"></p>}
        {isVerifiedId && (
          <div className="makeFlex perfectCenter paddingV8 appendTop8 appendBottom8">
            <input type="checkbox" onChange={handleCheck} />
            <label>{I_HAVE_MY_IRCTC_PASSWORD_FOR_THIS_USERNAME}</label>
          </div>
        )}
        {isVerifiedId && (
          <div className="makeFlex vrtlCenter gap15 appendBottom8">
            <span>Forgot password?</span>
            <a
              className={`font16 lineHeight20 latoBold`}
              onClick={goToForgotPassWordPage}
            >
              Get a new password now
            </a>
          </div>
        )}
      </Modal>
    </Fragment>
  );
};

export default withRouter(VerifyIrctcUserNameNew);
